import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {Container, Row, Col, Button} from 'reactstrap';
import {connect} from 'react-redux';
import {
  getCustomerAbroadPackagesBusinessIndividual,
  getUsageData,
} from '../../Shared/abroadThunk';
import { getCustomerAbroadPackages,getCustomerAbroadUsageDisplay } from '../../Shared/abroadThunk';
import images from '../images/images';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import './ExtendedPackageSurfPopUp.scss';
import {formatPackageDurationLabel} from '../../cellcomAbroadUtilities';

function ExtendedPackageSurfPopUp({
  onClose,
  extendedPackageData,
  abroadAddSoc,
  mobile,
  otpTicketId,
  businessId,
  privateId,
  getCustomerAbroadPackages,
  getCustomerAbroadUsageDisplay,
  getUsageData,
  cellcomAbroad,
  portalsBlock,
}) {
  const btnTxt = `רכוש את החבילה`;
  const header = `?רוצה להמשיך לגלוש`;
  const lineTxt = `לא מעוניין הפעם`;
  const socCode = extendedPackageData ? extendedPackageData.socCode : '';
  const surfData = extendedPackageData?.packageDetailsList ? extendedPackageData?.packageDetailsList[0].data.value : '0';
  const duration = extendedPackageData?.packageDuration || '0';
  const durationLabel = formatPackageDurationLabel(duration, extendedPackageData?.packageDurationUnit);
  const cost = extendedPackageData?.price || '0';
  const dataBoxStrongTxt = `חבילת גלישה של ${surfData}GB`;
  const dataBoxReg = `שתיכנס לתוקף מיידי למשך ${durationLabel}
                        בעלות של ${cost} ש"ח`;

  useEffect(() => {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_SHOW_EXTENDED_SURF_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_SHOW_EXTENDED_SURF_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_SHOW_EXTENDED_SURF_POP_UP.eventParams,
    );
  }, []);

  function goBack() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_QUIT_EXTENDED_SURF_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_QUIT_EXTENDED_SURF_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_QUIT_EXTENDED_SURF_POP_UP.eventParams,
    );
    onClose();
  }

  async function triggerBuyPackage() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_BUY_EXTENDED_SURF_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_BUY_EXTENDED_SURF_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_BUY_EXTENDED_SURF_POP_UP.eventParams,
    );

    if (socCode == '') {
      return;
    }

    const data = {
      socCode: socCode,
      phoneNumber: mobile,
    };
    await abroadAddSoc(data);

    const packageData = {
      mobile: mobile,
      privateBlockId: privateId,
      businessBlockId: businessId,
      goldBusinessPackagesBlockId: cellcomAbroad.epiStyleInitializationData.goldBusinessPackagesBlockId,
      showPopUp: true,
      addonsFolderBlockId: cellcomAbroad.epiStyleInitializationData.addonsPackagesFolderId,
    };
    if (isBusinessIndividual) {
      packageData.phoneNumber = mobile;
      //packageData.goldBusinessPackagesBlockId = cellcomAbroad.epiStyleInitializationData.goldBusinessPackagesBlockId;
      packageData.blockId = businessId;
      packageData.orgId = portalsBlock.privateCompanyList.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgId;
    }

    const usageData = {
      mobile: mobile,
      isBusinessIndividual: cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
    };
    const packagesReq = isBusinessIndividual
      ? getCustomerAbroadPackagesBusinessIndividual(packageData)
      : getCustomerAbroadPackages(packageData);
    const usagesReq = getCustomerAbroadUsageDisplay(usageData);
    const usageDataReq = getUsageData({
      subscriber: mobile,
      toReport: false,
    });
    await Promise.all([packagesReq, usagesReq, usageDataReq]);
    onClose();
  }

  return (
    <div className='ExtendedPackageSurfPopUp-container'>
      <div className='surf-header'>{header}</div>
      <Image src={images.extendedSurfPackage} alt='surf' className='surf-img' />
      <div className='surf-data-box'>
        <div className='data-box-strong'>{dataBoxStrongTxt}</div>
        <div className='data-box-reg'>{dataBoxReg}</div>
      </div>
      <BtnSubmit text={btnTxt} onclick={() => triggerBuyPackage()} />
      <div className='cancel-line' onClick={() => goBack()}>
        {lineTxt}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  extendedPackageData: state.cellcomAbroad.extendedPackageData,
  businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
  privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
  cellcomAbroad: state.cellcomAbroad,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  getCustomerAbroadPackages,
  getCustomerAbroadPackagesBusinessIndividual,
  getCustomerAbroadUsageDisplay,
  getUsageData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtendedPackageSurfPopUp);
